import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  padding: 0 24px;
  max-width: 1232px;
  margin: 0 auto;
  .action,
  .headerL,
  .headerM,
  .headerS,
  p.action {
    font-weight: 400 !important;
    font-variation-settings: "wght" 700 !important;
  }

  .headerL,
  .headerM {
    margin: 0;
    color: var(--text-primary, #faf8f7);
  }
  span.headerM {
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 0.32px;
  }
`;
